import JwtDecode from 'jwt-decode'

export default class User {
    constructor({id, email, role, first_name, last_name, orgs, app_type}) {
        this.id         = id;
        this.email      = email;
        this.role       = role;
        this.orgs       = orgs;
        this.app_type   = app_type;
        this.first_name = first_name || '';
        this.last_name  = last_name || '';
        this.name       = this.first_name + " " + this.last_name;
    }

    static from(token) {
        try {
            let obj = JwtDecode(token);
            return new User(obj)
        } catch(_) {
            return null
        }
    }
}
